import styled from 'styled-components'

const Box = styled.div`
    display: flex;
    align-items: center;
`;

const ToogleContainer = styled.label`
  display: inline-block;
  position: relative;
  width: ${({ width }) => width || '60px'};
  height: ${({ height }) => height || '34px'};
  user-select: none;
  cursor: pointer;

`;
const ToggleText = styled.span`
  text-align: center;
  font-size: 14px;
  line-height: 1rem;
  user-select: none;
  margin-left: 6px;
  color: ${({ labelColor }) => labelColor ? labelColor : '#111'};
`;

const ToggleSlider = styled.div`

  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 34px; /* Added prop for size */
  transition: .4s;
  

  &:before {
    //Bolinha
    position: absolute;
    content: "";
    height: ${({ height }) => parseInt(height || '34px') - 8 + 'px'};
    width: ${({ height }) => parseInt(height || '34px') - 8 + 'px'};
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: .4s;
  }


`;

const CustomInput = styled.input`

    display: none;
    &:checked + ${ToggleSlider} {
        background-color: #40e5a0;
    }

    &:focus + ${ToggleSlider} {
        box-shadow: 0 0 1px #40e5a0;
    }

    &:checked + ${ToggleSlider}:before {
    transform: translateX(
        calc(${({ width }) => parseInt(width || '60px') - 8 + 'px'} - 100%)
    
    ); /* Adjusted size based on prop */
    }

`;






export function ToggleButton({ style, width, height, label, labelColor = '#111', option, changeOption }) {


    return (
        <Box style={style}>
            <ToogleContainer width={width} height={height}>
                <CustomInput checked={option} onChange={changeOption} width={width} type="checkbox" />
                <ToggleSlider height={height} />
            </ToogleContainer>
            <ToggleText labelColor={labelColor} className='toggle-text' Text width={width}>{label}</ToggleText>
        </Box>
    )

}